import { useEffect, useRef } from "react";
import jwt_decode from "jwt-decode";

function RefreshToken({ token, isLoggingOut }) {
  const intervalIdsRef = useRef([]);
  let { current: intervalIds } = intervalIdsRef;

  useEffect(() => {
    // Destructure current value from the ref
    console.log(isLoggingOut);

    const cleanup = () => {
      console.log(intervalIds);
      // Clear all intervals saved in the array
      intervalIds.forEach((id) => {
        console.log("Clearing interval:", id);
        clearInterval(id);
      });
      intervalIds.length = 0; // Clear the array without reassigning to a new reference
    };

    if (isLoggingOut === true) {
      cleanup(); // Clear all intervals if logging out
    } else if (intervalIds.length === 0) {
      console.log("I'm here", intervalIds);
      // Create a new interval and save its ID in the array
      let newIntervalId = setInterval(() => {
        sendFetch();
      }, 1 * 60 * 1000);
      intervalIds.push(newIntervalId);
    }
    // Update the ref with the modified array
    intervalIdsRef.current = intervalIds;
  }, [isLoggingOut]);

  const sendFetch = async () => {
    const checkTokenExists = localStorage.getItem("token");
    const decoded = jwt_decode(checkTokenExists);
    console.log({ decoded });
    if (checkTokenExists) {
      try {
        const response = await fetch(
          "https://femez.onrender.com/API/user/refreshToken",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("token", data.token);
          // localStorage.removeItem("restaurant_existence");
          console.log("Data received from the server:", data.token);
        } else {
          console.error("Fetch request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error while making the fetch request:", error);
      }
    } else {
      console.log(intervalIds);
      // Clear all intervals saved in the array
      intervalIds.forEach((id) => {
        console.log("Clearing interval:", id);
        clearInterval(id);
      });
      intervalIds.length = 0; // Clear the array without reassigning to a new reference
    }
  };

  return null; // This component doesn't render anything in the DOM
}

export default RefreshToken;
